
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="ChatArrowDownSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M12.129 15.332l-10-9.008a1.36 1.36 0 00-1.764 0 1.025 1.025 0 000 1.568l10.876 9.785a1.385 1.385 0 001.777 0L23.63 7.892a1.026 1.026 0 000-1.568 1.359 1.359 0 00-1.763 0l-9.74 9.008z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'ChatArrowDownSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
